"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_TEXT_EXTENSIONS = exports.VERSIONED_DOCUMENT_EXTENSIONS = exports.VALID_ARCHIVE_EXTENSIONS = exports.VALID_DRAWING_EXTENSIONS = void 0;
exports.dropDocumentVersionSuffix = dropDocumentVersionSuffix;
exports.isValidTextFileType = isValidTextFileType;
const file_utils_1 = require("./file-utils");
exports.VALID_DRAWING_EXTENSIONS = [
    '.catdrawing',
    '.dft',
    '.drw',
    '.dwg',
    '.dxf',
    '.idw',
    '.slddrw',
    '.tif',
    '.tiff',
];
exports.VALID_ARCHIVE_EXTENSIONS = ['.7z', '.gz', '.tar', '.tgz', '.zip'];
exports.VERSIONED_DOCUMENT_EXTENSIONS = new Set(['.drw']);
exports.VALID_TEXT_EXTENSIONS = [
    '.txt',
    '.csv',
    '.pdf',
    '.docx',
    '.rtf',
    '.odt',
    '.xlsx',
    '.ods',
    '.pptx',
    '.odp',
    '.xml',
    '.plmxml',
    '.json',
    '.yaml',
    '.yml',
    '.tsv',
    '.md',
    '.log',
    '.qif',
    ...exports.VALID_DRAWING_EXTENSIONS,
    ...exports.VALID_ARCHIVE_EXTENSIONS,
];
function isVersionedDocumentExtension(extension) {
    return exports.VERSIONED_DOCUMENT_EXTENSIONS.has(`.${(0, file_utils_1.getExtensionName)(extension)}`) && /\.\d+$/.test(extension);
}
function dropDocumentVersionSuffix(extension) {
    return isVersionedDocumentExtension(extension) ? `.${(0, file_utils_1.getExtensionName)(extension)}` : extension;
}
function isValidTextFileType(filename) {
    return exports.VALID_TEXT_EXTENSIONS.includes(dropDocumentVersionSuffix((0, file_utils_1.getFileExtension)(filename.toLowerCase())));
}
//# sourceMappingURL=is-valid-text-type.js.map